// extracted by mini-css-extract-plugin
module.exports = {"xstream":"XStreamNew_xstream__kisj4"};